import { orchestrator } from 'satcheljs';
import { onCloseAppPane } from 'owa-app-pane-group-actions';
import getDrawerPaneId from 'owa-app-pane-group-utils/lib/getDrawerPaneId';
import closeAppPane from './closeAppPane';

orchestrator(onCloseAppPane, ({ appPaneName, targetWindow }) => {
    closeAppPane(getDrawerPaneId(appPaneName), targetWindow);
});
